import { IconConfig } from "../types";

export const magnifyingGlass: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 51.433 51.433",
  elements: [
    {
      type: 'g',
      id: "_x31_556_x2C__Glass_x2C__Magnify_x2C__Magnifying_x2C__Search_x2C__Zoom_x2C_",
      transform: "translate(-10.866 -10.854)",
      children: [
        {
          type: 'g',
          id: "Groupe_2848",
          className: "Groupe 2848",
          transform: "translate(10.866 10.854)",
          children: [
            {
              type: 'path',
              id: "Tracé_2515",
              className: "Tracé 2515",
              d: "M80.259,65.55a14.7,14.7,0,1,0-14.7,14.7A14.713,14.713,0,0,0,80.259,65.55Zm-14.7,12.6a12.6,12.6,0,1,1,12.6-12.6A12.611,12.611,0,0,1,65.563,78.146Z",
              transform: "translate(-46.668 -46.655)"
            },
            {
              type: 'path',
              id: "Tracé_2516",
              className: "Tracé 2516",
              d: "M61.994,56.3,48.348,42.653a1.05,1.05,0,0,0-1.485,0L45.506,44.01l-1.67-1.67a18.917,18.917,0,1,0-1.484,1.485l1.67,1.67-1.357,1.357a1.05,1.05,0,0,0,0,1.485L56.311,61.982A4.019,4.019,0,1,0,61.994,56.3ZM12.966,29.749a16.8,16.8,0,1,1,28.81,11.723,1.05,1.05,0,0,0-.292.293A16.786,16.786,0,0,1,12.966,29.749ZM60.51,60.5a1.918,1.918,0,0,1-2.714,0l-12.9-12.9,2.714-2.714,12.9,12.9A1.921,1.921,0,0,1,60.51,60.5Z",
              transform: "translate(-10.866 -10.854)"
            }
          ]
        }
      ]
    }
  ]
}
